import React from "react";
import Drawer from "react-bottom-drawer";
import { useDispatch } from "react-redux";
import DeviceContext from "../customHooks/indentifyDevice";
import { useReportZIndex } from "../customHooks/useOutSideClick";
import { EelementId } from "@frameworks/web/components/Reports/constant";
let startY = 0;
let startScrollTop = 0;
const GenericDrawer = (props) => {
    const dispatch = useDispatch();
    const device = DeviceContext();
    // React.useEffect(() => {
    //   if (props.show) {
    //     dispatch(di.footer.updateShowMob_Menu(false));
    //     di.header.RemoveHeaderData(false);
    //   } else {
    //     //dispatch(di.footer.updateShowMob_Menu(true));
    //     di.header.RemoveHeaderData(true);
    //   }
    // }, [props.show]);
    React.useEffect(() => {
        const element = document.getElementById("ymPluginDivContainerInitial");
        if (element && (props === null || props === void 0 ? void 0 : props.show) && (device === null || device === void 0 ? void 0 : device.isMobile)) {
            element.style.zIndex = "0";
        }
        return () => {
            if (element) {
                element.style.zIndex = "999";
            }
        };
    }, [props === null || props === void 0 ? void 0 : props.show]);
    const callBackRef = (node) => {
        if (node) {
            const commondrawerscroll = node.getElementsByClassName("common-drawer-scroll")[0];
            const handleTouchStart = (e) => {
                const touch = e.touches[0];
                startY = touch.clientY;
                startScrollTop = commondrawerscroll === null || commondrawerscroll === void 0 ? void 0 : commondrawerscroll.scrollTop;
            };
            const handleTouchMove = (e) => {
                const touch = e.touches[0];
                const deltaY = startY - touch.clientY;
                const newScrollTop = startScrollTop + deltaY;
                if (newScrollTop <= 0) {
                    commondrawerscroll.scrollTop = 0;
                }
                else {
                    commondrawerscroll.scrollTop = newScrollTop;
                }
            };
            commondrawerscroll === null || commondrawerscroll === void 0 ? void 0 : commondrawerscroll.addEventListener("touchstart", handleTouchStart);
            commondrawerscroll === null || commondrawerscroll === void 0 ? void 0 : commondrawerscroll.addEventListener("touchmove", handleTouchMove);
        }
    };
    useReportZIndex(props === null || props === void 0 ? void 0 : props.show, EelementId.REPORT_NAVBAR);
    return (React.createElement(Drawer, { className: `backgroundcolor_bluedrawer px-0 ${props.parentClass}`, hideScrollbars: true, isVisible: props.show, onClose: () => props.setShow() },
        React.createElement("div", { className: `drawer-head ${props.headerClassName}` }, props.headerComp),
        React.createElement("div", { className: "drawer-body bg_white", ref: callBackRef }, props.bodyComp)));
};
export default GenericDrawer;
